import Button from '@jetbrains/ring-ui/components/button/button'
import * as React from 'react'

import {usePermission} from '../../../hooks/usePermission'
import {Permission, ROOT_PROJECT_ID} from '../../../types'
import {createRootSubprojectLink} from '../../pages/ProjectPage/ProjectPageHeader/ProjectCreateSection/ProjectCreateSection'

import styles from './ProjectsTree.css'

type Props = {
  searchQuery: string
  searchActive: boolean | null | undefined
}

function ProjectsTreePlaceholder({searchActive, searchQuery}: Props) {
  const hasPermissionToCreate = usePermission(Permission.EDIT_PROJECT, ROOT_PROJECT_ID)

  return (
    <div className={styles.placeholder}>
      <span>{searchActive && searchQuery.length > 0 ? 'Nothing found' : 'No projects yet'}</span>
      {hasPermissionToCreate ? (
        <Button href={createRootSubprojectLink} className={styles.createButton} rel="noreferrer">
          {'Create project...'}
        </Button>
      ) : null}
    </div>
  )
}
export default ProjectsTreePlaceholder
